import { render, staticRenderFns } from "./settlementDetail.vue?vue&type=template&id=47416108&scoped=true"
import script from "./settlementDetail.vue?vue&type=script&lang=ts"
export * from "./settlementDetail.vue?vue&type=script&lang=ts"
import style0 from "./settlementDetail.vue?vue&type=style&index=0&id=47416108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47416108",
  null
  
)

export default component.exports